const $ = jQuery;

const DeliveryPrice = {
  init: function () {
    $(".delivery-price").on("click", function (e) {
      e.stopPropagation();

      let content = $(this).siblings(".section-delivery-price");
      if (!content.length) {
        content = $(".section-delivery-price");
      }

      if (content.hasClass("active")) {
        DeliveryPrice.close(content);
      } else {
        $(".section-delivery-price")
          .removeClass("active")
          .css("transform", "translateX(100%)");
        content.addClass("active").css("transform", "translateX(0)");
        $("body").addClass("delivery-price-active");
      }
    });

    $(".section-delivery-price").on("click", ".icon-close", function () {
      const content = $(this).closest(".section-delivery-price");
      DeliveryPrice.close(content);
    });

    $(document).on("click", function (e) {
      if (
        !$(e.target).closest(".section-delivery-price, .delivery-price").length
      ) {
        DeliveryPrice.close($(".section-delivery-price.active"));
      }
    });
  },

  close: function (content) {
    content.removeClass("active").css("transform", "translateX(100%)");
    $("body").removeClass("delivery-price-active");
  },
};

export default DeliveryPrice;
